import { render } from "./GeneratePopup.vue?vue&type=template&id=2bbe4759&scoped=true"
import script from "./GeneratePopup.vue?vue&type=script&lang=js"
export * from "./GeneratePopup.vue?vue&type=script&lang=js"

import "./GeneratePopup.vue?vue&type=style&index=0&id=2bbe4759&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbe4759"]])

export default __exports__